

export const Bio = {
  name: "Mounika Adada",
  roles: [
    "MERN Stack Developer",
    "Frontend Developer",
    "React js Developer"
  ],
  description:
    "I am a motivated and versatile individual, always eager to take on new challenges. With a passion for learning I am dedicated to delivering high-quality results. With a positive attitude and a growth mindset, I am ready to make a meaningful contribution and achieve great things.",
  github: "https://github.com/mouni2619",
  resume:
    "https://drive.google.com/file/d/1xS-RfFRuS8obebP-Uc4dge9E0CqfFTWI/view?usp=sharing",
  linkedin: "https://www.linkedin.com/in/mounika-adada-7a1b55243",
 
};

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "React Js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      {
        name: "Redux",
        image:
          "https://d33wubrfki0l68.cloudfront.net/0834d0215db51e91525a25acf97433051f280f2f/c30f5/img/redux.svg",
      },
      
      {
        name: "Bootstrap",
        image:
          "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
      },
      {
        name: "Material UI",
        image:
          "data:image/png;base64,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",
      },
      {
        name: "Tailwind CSS",
        image:
          "data:image/png;base64,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",
      },
      
     
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "Node Js",
        image: "https://nodejs.org/static/images/logo.svg",
      },
      {
        name: "Express Js",
        image:
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAAY1BMVEWCgoL////l5eXk5OTm5ubu7u74+Pj19fXx8fH7+/vr6+t+fn52dnZ7e3t8fHzz8/OGhoaTk5Pa2tq3t7e7u7utra3Q0NCZmZnFxcWkpKSMjIzKysqpqanX19e/v7+dnZ1ra2tH/Sn9AAASPElEQVR4nOVdbZuyKhBWwTcErcxqa7fO//+VB9RKGF6tdvWc+bLPNY+m48DMzc0AURzHWYKTjP9FOEn5nzTBaKJNPLW5UYtxQozawqYtH1o8V4ui/4eFKEG9hcn4fgmaqU2S0ZaHNndpi0Fbjlr8Ni0atVGWZXmapjn/y/8U/E/B//6etnmnttFoI/4BemcgxUVBWuLS8iaES/6XENLwPw1vSpPPngzXPj67TYtDtIhrI6ztZm/pkuKZDbcpLgt0uV73+7b74tJ1bdterztUZDgl5Se6JJpoP+ZD/uNNnKNTdztHlFJWV7LUjCuj8609oIx/hfRzPvxI3yqanBzaIzeNGxbZpKq4pdG2PeBcdKKXepyhH747lgotut4iyuymKYYyGt1O6aRpvi+WvrXzYZKSXbehDscZrKxp1F1wms7sfNZ8iAa/oLGbIeSjJRrt9RjmO+hLtj31HkDD+6GhS6Kxm3losaKNAs0yG9uQ042+Yt1dano8lS+ahT6QLUjH2BvMG42sOxKTt2WLV8MLwqT42b7FfU+p6PYkUunrQSd6PUU0pK3e576nsKgl8euJQ84W4ck/IWj/UmyxScW+EQlO/gi9M1vkqPuYfYONXfGWbDHbh+1H7Rts3AdCNUX7Qj/M8lNUf9g+IXV0KssX+uH8WIo2n4gvOmFnFAjVprF0bj7Mvukv2SeEfudkbj6cBdUScnhz/nMJ745kHoCbh0uz2286cBB2K3NvqDbFpeHZAse/7cBBKnpKfZvmS1wbSY6/78BB2FGid/wAXPAYvznMGvy9R6rqEH+Ya0ua6185cBDaEm1eQO/i2vDxt3KgSdgRuUmA2Vwb2W3+roXepdqgIAAX0g/zw187cBB2yD/DtaXt33bBp/DO6IBqs0ZP6dcyPCiEfZXeAM4b0xTH3xhH+Aq72aHaFNP4RRqcnP8+xkylOqO3ZguMFhBEZRlCqgmqhXJtJdr8tUE6yd/GtZVkaQ4cJS0n75tqE0fqw7VhtFADo2j3Fq4NL7OJ9rJ5C9eWLNdAHlHdAM7ZD/OFpQlZqm2hQrU8kGtLj0s2kJt4dAE4Rz5Mv5aEZHRS6wCcP9eWt8vBoiahJzuAs0YacljKaMIm9IKtkcaWLXbL96AQtsMWAGcZHyZ4wXlCkk0410Z6Vm3hYfQp1TZWoJoX19Zc19FGhbCOhI+e8M8aosxd6CGYa8PJX790mFTBXFu8mk44SHUsIdeW27i2VWTCqdALCeHakmxtBnITrflQ5drIbV1ttJctCeDaVtdGhdCDPtLossUK26gQmjW+XNv3Ctsol+o7s3NtZEwcGVqnC7kTf0YriJ1ry9cCuKGc/bi203rwqCrs4sW1/fVrviKVB9fWtEtnZmxSt42La0vQetuoELZzcW2kW2emuEvVObm2dbtQpH0719bs1+1CkfaJbWyBydpdyIONNVuQdu0u5E5sCeTaSErEGJ+kxfoN5CYWI9c2ADh59PQT3EjF4roqOh+3x/OG/5u5y/oAJvT9qup1GwO6ZD+xmWvbej5sfCSj5/ZARAMfJCM/+1tlLz5lRawI8QP61Zd649Fw5TZOTFyb57PGV2VfP6X6UCGojay/A27wI2Yr9TbjrBFFyXQEnOcj15ZnTUC2p+eDzrpRdluzjdAX8dbjuTRRbjLzuVVX5gPXlitcm3+qoEdksa935Nn4Y/SiXty42w5rlXtyy8uy2JAPfYdNbLNz2CfkZHxtmqrXXpxPPqu32PzODgau7eZnIL162Ce+4tk0StmAa13tlKrxyTp1W91kru1BknrFmaqv8PCTzvCL9bd6pYP7omqn3zmuR4lubHH1iTMUxgmLXAwvAt7YEjciTXDKHK262uPHngVPH6am9CK92j7EQPO3Zo16pY2DBoni7HrPSYUGH+OTYYzvkwxhGJxrIogcpZlaoGrgdtdPUJJDrs1j0h42LrcYmh+I/uauBS51dML+nl0Os4U73fd1HUDK5HDat/vrAWW6/zZlDQoyjomHVt1ty4R3qbocjp6cLCnr4Ovj9nzf1YND8HOrAg8hX/o3ZwDy6R8LEoUPAoo2mcy1cZDjJLqrLXj3n7OCsistmNN/O/h72lcAXd+viIlibpTEtRVO+oKpjRCddW+kATzY0BUBcuhgtBHJWxKPTtj/uPgwUj5sDG3pIaDfGFdfwJRpYA5AjNRkgUppy65M+LhPgAqJa8t97phIaUbWfKiqAk/TtaqFIGOBj+DVCe+/PeXasCsbKnGhtI/M1RczLCcCTTDeyxeCRLH3H/7s5P3asGNJk9pnXNQDxfL1hkANEYTcTtVE4dkJhdQnOVs4SbbQtkJlWGYigKgK49OpDWqi8O2EQqqWTLk20thBKZNzgE/AVj6/6TIwkJoMUoGH/Tshl2Mjc232q2Xo6zXMUrrQyQA71Qg2YcNALw0s55W5Nvv4rJZ7oRPZ9yI3sdKYW1SIkN+vVEFPQCfsfziXuDY7oqH59EmepSiKC4zVDwCVjYNKNR6XgVwuv//OteV52pgake5d/VyoRhHz0AUMpPqSOpAoQgvt6lPT2zbEUvusIZPgjHdjUbqY0UKA6HtvqXYH19RX3VAbPeRDYiWhqPQoF7ybvLrnffRHsYb3AzWNzKiAuZGnhYjYWp7Ckvh/Sya9uYUxrKV+Lr6GmihCO6GQ82jhEEttV9bSwDcgolVS80vNN4KBVKkmiqBMeJfp2MIYy4XIDSZkklhOo5YLmYPg8oej0x8tJ1xbYbNQ7k4hdZkydLPdCQdSU5lXhkaLwYeEkKK0/sRRelpISZgchK3eB4ThRLJ5FT4MpYSk5RBLbfMGlZyYgibgpHhhnX6t5O8oycyS8/7pYyzFV8tXklF3wzb+EkndyxJqxGO0RJ6Ques+6v3UQttEjmsizVcsnK8QMJAaZXYtaHWNH1xbaesicC5srji6MJyR6r/L7OKJ6ppz2/IhllotfJeBrioBzeRwPLsTit/bk2c+tI3w32ehk87TcK0vLL7iFj65Nhvwrt9mobMcSdMVZ9snIBV5cG3E9nX13WOOOOGQpp3aA7D718ZY+ksWWgeh/TvpbpptYj+svVtoA1RggDpbXPUIeug2O9TcLRR8VGHz4fv6ocNCOKXYiyONWiz8ikWx3sDT2CIN0z53loX2dzU1lrkp/x5p+mxhs1DOFqL8dqZgeywFjNRDunkZo+rSJ9dmzYfSAJz8Q2eL3UDLDLov96VYyDP+nWtrbBYyaQrihehtfx0wSfPyQ6s2e3Bt1vYjD/I+ZqHFQHNdjv0nReTyGVvINI2V75gvgP5VTJyz4vM+thgstI2AZTrzIxaqiaJQYcacEUY9+rCPpdZamvkshreoiWILaq9mpAy2688eGCy03i8nRJ/asFBRh6AnBkF4+D4yFBFPrk1OVB9YNaTSv31BLcj/wSmDNhOuzTq55k1dzxSQKHpbAIXqUUgsC82eXBvC1jeQwkBQtbuXqIliDHugnQanjOnMTGptAnKDmWuISdRCnUfGBe00MGWcpZkZ+9yTVA0V0hHZVAyXqCOKs/F/Aj/ubfRhURRNXlpBsdwRDTVc2hsvu4noiSjVU5MpCrVkJSxlVG3JbbtzbaaSnvFamVzwX1gj5xntJWqikLu56sSQGRp2kOra7F9HflP/SWDpy2hDFFMLSqSAUIN6z4BlS2Ief1LXZq/FkJup92PkGKJjaUCiUJwEeI2AlMGjx7OuLcHEfrUM3HzHFzK41IEhlSGBfVx1YsCeJESU85bJ3UI7GFN6ix//JY9pdRVboKITJK0KtFPvMoIjCalrUx/ks5uiMl+mwUKgm2mwJ+TfPA2c1rWVOQc3jtpEqtQS+MyrO9wDE4U+D6kW+i3t4TFMrCEts0ddmyPLgfIz5wkClVw0rQnAYFJLOzCD8dQvZYgZdmkNqatGGGRf05qm0b6NUhUO469viTpsp36xPFbWkDYu0AdQ4o/lMCtQ6g1dCBKFOSWrT8492ulQ5/3g2ji4yVyTCrCyPm4N/CCLADMIG6Baom4mD2A79UgZ9bXhiE3Y9lhR4kxymqmvvGPAkRWN4Iw83C8Flv5b1j2B9Q3ulEF3GKwKchMwunXNh+/oeRJuzejmW7O+FDZA4BcrbAT+dqeMTQbXkDpHRZpFM4Mnd5e9OMq42192aoFaLw0MIaBX258M5hVdA5yqfZwNxWMp7tcfYjc9UQetrnwKbB2gxTs+L2ynjtlvdhlOXcaTNaQYu9MMm2Ui3BAcLIJzDvzgMjA75mDJzDWkzDa7oJccLs2AcxTOB8Nb7CsTpmtIB66tLEjqnITmUp/1iwyNomsZteoQD2IEVNlaU0Z9SnNu1IRrG3Yc8Bsx+KzFf4huFAJ+wWtIDdvptyW/GHYc8FuPT8EKCaPkuhPaYAL3eqxm+s2Y3/r1+LodeDz3VKgA9WCQkxbzgEThSd7BdmpMGYKTePqw59rynGOcwrsmgG08ljxfIu0HA4nCm/aB7dSUMmg+GDXl2ob92vypUFZdtcn9LunecAgySBT+82bem6KIzbAM+7WFMPbifHBDvSQ+Gc+whoWyATuJwnaqJ9Aowsb92sL2GKppddwfyMSZOTmITYYsrV19x6DFTGApcqzdXm4bg/3a7uePkfBtL8UidVZtztvteRP1/7b65HzcyhL2tI1y91aHUtipX7rN/RhPuLZxvzYHqbgS+d/t11aWgmsjOf/L/6Tr33OPCahWlg23JisnXNu42/VaN0l+ipjPtZ6N8B/Z+9JyNgJZuRN7jk3esXzk2sY/Ta6hHNYkrCgGa5pC5dri+9kItvUzi5f66nM2wpqbaeV1NsLa9/NWz0Z4cG09yBFbZJTzClaXIBsyQjWMn7EUno1gX424ZKE/WDkbQbPbNcK8wfov116UiLMR7hYihWsry4L/fQA4n920Figsf0C1Jwwt5WwxJn+yosOsnsLGrQS9ziFNV3nOTBpyDumHyrk/KfTR+RQfTri2CYDLV5cU2amUrNBzbRN3ktWd2dXEmlPJrOeQ/vU7B0oSfA4pXtWZT/ez80znkHJbe65NAnAzquP/TEQZhQTVjFybfJjHarpiP/8uQTWQLTDSWJgs+bxqSTYAqk0tlLk2CcClazlLFqUqVDNzbUryX0W0EdMZKlTzOYc0WdWZzrZTq60+TMnX0k1kw7ncifkcUhnkKACuycuFY/DqFuugmpVrUwEcLIdZkFRnPVTzPZd7mHNbcs7YTDpfEnIOqQzg/toMi5igmoVrGwGcpHXVD/+dZCXWQjVs59pgg13qIUm5Eaq5uDbVwnKJDbXiBhqhmotrgwAOb5bmxuqMSzNUc3FtcvIf4s/CkoZIExaoFpYtBm0xa3PGT0l9hHnBmi2sPrwDuNtyABy7OaCamWtrLAAu3i9lpEH3LqjmwbWNWtmd12WYKBbFOaCaF9em0ZKfJfTFeufufD5cm1aLkfGUqt8Sdu7fzAHVDFybB4CLy++/bam0Hd5MhmpYhWoTrSVbID0D9/5tIwKk3yzHA6r5cW0GLbEci/dhYVuEVVCmh2qeXJsEiCba8o/SBt0X/Ttk2jcL5dqQTUt2f+BGdu6PzEy8oJo316YHcFxL9HX4n5OKtinW5AWPbGHn2sza/PabTZXeUqIHZU5tZIRqDm2TGZYbfEBYdMkAiNRDS6jVcW2q4wzaIr5algK/Typ2JcQIyt7BtVm0PP9/2saKdplf53uBazNoxe/ku9tHbazokUwDqATK9FoL1yaSKYRqd21u0hZfH7OR+6+IG/AOE1DmAeAgE2UBcIlWS1BHPxFzatohXQbwgWqhXJtdy7Njetm82ZEV3Vwx8QBl7+LaTADufm0c777e6EhGv3ZxagNlZqimal+MNA9tgsv4YFzQFSQ8uhxSgsNjiiHSvJQtplrx62i/pS/lyKqm22s2Ly+8zLX5aHmXJGKXhXqOlVXFou6EyDCE9wVl7+HaQrR5nmXodItYkJUVo9HtuhNbbweCMqfWiLyDAJxGuzt9b/stM5ztkhu37U48WDV4Bih7L9cW0iV5b2jiHJ262zmilD12B6meu4RQGp2P3QWJ0Jc+u87zF5LZnW821+YVViVtI5Ja2aDLdb/ft93X7fbVdW3b7q871GT8P6VRrQcoCw6req5tJoC7ayGk6ktXSJ/BY5KSHgoRy7VWUBYG4KxMVBCAy21aArVyI9RrZ0O1l7g2K4BLVG0+aIlR+yoo+wjX9prWC369rn0AuE9HmlTu+3rtRyPNv+c/cIe0nzmlAAAAAElFTkSuQmCC",
      },
    
      
      
     
      
      {
        name: "MongoDB",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
      },
     
      {
              name: "VS Code",
              image:
                "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
            },
            {
              name: "Postman",
              image:
"https://cdn.worldvectorlogo.com/logos/postman.svg"            },{
  name: "Git",
  image:
    "data:image/png;base64,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",
},
{
  name: "GitHub",
  image:
    "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
},
      {
        name: "MySQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },
      {
        name: "SQL",
        image:
"https://w7.pngwing.com/pngs/167/148/png-transparent-microsoft-azure-sql-database-microsoft-sql-server-database-blue-text-logo-thumbnail.png"      },
     
    ],
  },
 
  {
    title: "Soft Skills",
    skills: [
      {
        name: "Good Communication",
        image:
          "https://i.pinimg.com/originals/29/bb/f6/29bbf61ee2561324423e7259dc9b0609.png",
      },
      {
        name: "Problem Solving",
        image:
          "https://static.vecteezy.com/system/resources/thumbnails/015/561/376/small/idea-solution-illustration-on-a-background-premium-quality-symbols-icons-for-concept-and-graphic-design-vector.jpg",
      },
      {
        name: "Leadership",
        image:
          "https://static.vecteezy.com/system/resources/thumbnails/000/577/853/small/6-01.jpg",
      },
    
      {
        name: "Time Management",
        image:
          "https://png.pngtree.com/element_our/png/20180904/success-time-management-png_83908.jpg",
      },
      {
        name: "Quick Learner",
        image:
        "https://thumbs.dreamstime.com/b/fast-learner-icon-fast-learner-147174346.jpg",
      },
      
    ],
  },
];

export const experiences = [
  {
    id: 0,
    img: "https://media.licdn.com/dms/image/C4D0BAQEWt2xg-Uk82w/company-logo_200_200/0/1650873321130/aurbindo_emergency_medical_services_logo?e=2147483647&v=beta&t=J0w9RKeVNAinNc6H94EtmD9ncBLEwffKDH7TmhYKa3g",
    role: "Data Entry Operator",
    company: "Aurobindo Emergency Medical Services",
    date: "Aug 2020 - July 2022",
    desc: "Performing meticulous data entry tasks to ensure the accurate recording and processing of medical information vital for efficient operations within 104 Aurobindo Emergency Medical Services.",
    skills: [
      "Communication Skills",
      "Organizational Skills",
      "Typing Speed and Accuracy",
      "Problem-Solving Skills",
      "Confidentiality",
      "Multitasking",
      
    ],
  },
  {
    id: 1,
    img: "https://pbs.twimg.com/profile_images/1450067030489579531/VrLa0SLu_400x400.png",
    role: "Data Operation Analyst",
    company: "Neilsen India Pvt Lmt",
    date: "April 2023 - October 2023",
    desc: "Proficiently trained and experienced in executing acquired instructions to meticulously report brand exposures and iterations from both sports and non-sport media content, ensuring adherence to strict timelines within a dynamic media evaluation and reporting environment.",
    skills: [
      "Adaptability",
      "Data Analysis",
      "Data Quality Assurance",
      "Collaboration",
      "Attention to Detail",
    ],
  },
  
];

export const education = [
  {
    id: 0,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS8RgSWl5AiCpEcAQMUDaIfFCUP1hsMzHkdO_cSoFm5lWQeq86JWI6uUp_o90tIIYc6QfI&usqp=CAU",
    school: "Bhimavaram Institute of Engineering and Technology",
    date: "Oct 2019 - Sep 2021",
    grade: "7.0 CGPA",
    degree: "Master of Business Administration in Human Resource",
  },
  {
    id: 1,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRuhSG5rexuvlrI8gtP8lzXpdtBNUetRuCS_RMk5-UnZQ&s",
    school: "Aditya Degree College",
    date: "Apr 2019 - Apr 2025",
    grade: "87.7%",
    degree: " Bachelor of Science in Computer Science",
  },
  {
    id: 2,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS6GemWtZ0Wof9luKM423P7kSm6YTvjzbJsOGeStwQR9w&s",
    school: "Aditya Junior College",
    date: "Apr 2017 - Apr 2019",
    grade: "71.3%",
    degree: "Intermediate, [M.P.C]",
  },
  {
    id: 3,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQsRpKhHgelKLHuD5WW4QpZ5LOXotsr_sl5qc05DZ-SgQ&s",
    school: "Sri Chaintanya Techno School",
    date: "Apr 2017 - Apr 2019",
    grade: "8.5 CGPA",
    degree: "SSC, [M.P.C]",
  },
];

export const projects = [
  {
    id: 0,
    title: "Markdown Viewer",
    date: "April 2024 - April 2024",
    description:
     "The ReactMarkdown project ensures a smooth user experience, storing all records securely in MongoDB. Users can register, log in, and reset passwords via email. The app is user-friendly, allowing users to create, edit, and manage projects, with responsive design for all devices.",
    image:
    require('../components/projectimg/mdf.png'),
    tags: [
    
      "React Js",
      "Node Js",
      "Express Js",
      "Nodemailer",
      "MongoDb",
      "Netlify",
      "Material-UI",
      "Bootstrap",
    ],
    category: "web app",
    github: "https://github.com/mouni2619/ReactMarkdown-FE",
    webapp: "https://rmf-nine.vercel.app",
  },
  {
    id: 1,
    title: "Taskify",
    date: "May 2024 - May 2024",
    description:
"Taskify is a full-stack web application designed to enhance productivity by allowing users to efficiently manage their tasks and projects. Users can create, edit, and delete tasks, categorize them, and track their progress. Taskify supports user authentication through Google Auth and JWT, ensuring secure access. The application features a responsive user interface built with React JS, providing a seamless experience across all devices.",    image:
    require('../components/projectimg/taskify.png'),
    tags: ["React Js", "MongoDb", "Node Js", "Express Js", "Redux","NodeMailer"],
    category: "web app",
    github: "https://github.com/mouni2619/Taskify-Fe",
    backend:"",
    webapp: "https://taskifyfrontend.vercel.app/",
 
  },
  {
    id: 2,
    title: "NutriPath",
    date: "Oct 2022 - Present",
    description:
"NutriPath is a comprehensive web application focused on promoting better health and nutrition management. It empowers users to track their daily food intake, monitor nutritional content, and receive personalized diet suggestions. The app features robust user registration and meal creation functionalities, alongside tools for nutritional tracking and BMI calculation for tailored dietary recommendations.",    image:
    require('../components/projectimg/nutripath.png'),
    tags: [
      "React Js",
      "MongoDb",
      "Node Js",
      "Express Js",
      "Redux",
      "NodeMailer",
    ],
    category: "web app",
    github: "https://github.com/mouni2619/NutriPath-FE",
    backend:"",
    webapp: "https://nutri-path-fe.vercel.app/",
  },
  {
    id: 3,
    title: "ChatApp",
    date: "Jan 2023 - Mar 2023",
    description:
"ChatApp is an intuitive and user-friendly MERN-based web application designed to enhance communication. It provides a seamless platform for users to engage in real-time conversations. The app features robust user registration, allowing users to create and join chat rooms effortlessly. Users can communicate with message history and notifications for a smooth user experience. ",    image:
    require('../components/projectimg/Chatapp.png'),
    tags: ["Reactjs", "Nodejs", "Expressjs", "Mongodb", "", ""],
    category: "web app",
    github: "https://github.com/mouni2619/chat-fe",
    backend:"",
    webapp: "https://chatbackend-7do1.onrender.com/login",
  
  },
  {
    id: 4,
    title: "Todo Web App",
    date: "Feb 2024",
    description:
"The provided code is a simple Todo application built using React. This application provides a user-friendly interface for managing tasks, including adding, deleting, editing, rendering and filtering todos based on their status. It leverages React's component-based architecture and state management capabilities to create a responsive experience.",    image:
    require('../components/projectimg/todo.png'),
    tags: ["React Js", "React-DOM", "Bootstrap", "CSS"],
    category: "frontend",
    github: "https://github.com/rishavchanda/Todo-Web-App",
    backend:"",
    webapp: "https://rishav-react-todo.netlify.app/",
  },
  {
    id: 5,
    title: "UserData",
    date: "Feb 2024",
    description:
"This is React Axios Task. I used React and Axios to interact with a mock API for user data. I displayed existing API data in the UI, allowed users to perform CRUD operations (Create, Read, Update, Delete) on user records, and ensured that changes to user data were stored in the mock API. I also created a clean and responsive UI",    image:
    require('../components/projectimg/users.png'),
    tags: ["React Js", "Axios", "React-DOM", "MUI", "CSS"],
    category: "frontend",
    github: "https://github.com/mouni2619/REACT_AXIOS",
    backend:"",
    webapp: "https://legendary-kitsune-5126c0.netlify.app/",
  },
  {
    id: 6,
    title: "Library Management System",
    date: "Mar 2024",
    description:
"Our Library Management System Admin Dashboard is a user-friendly tool for managing books and authors. It allows you to easily add, edit, and delete book and author details, perform CRUD operations on user data, and access up-to-date information through API integration. The dashboard is responsive, works on all devices, and has a modern design",    image:
    require('../components/projectimg/library.png'),
    tags: ["React Js", "Formik", "MUI", "TailwindCSS"],
    category: "frontend",
    github: "https://github.com/mouni2619/React-Formik",
    backend:"",
    webapp: "https://voluble-rugelach-7c1d1b.netlify.app/",
  },
  {
    id: 7,
    title: "Caluculator Using DOM",
    date: "Dec 2024",
    description:
"I have create a Calculator using DOM.I used Keyboard and mouse events for numbers.I added functions to perform addition, subtraction, division, multiplication and modulus.Calculator app is responsive for all media screens.",    image:
    require('../components/projectimg/calc.png'),
    tags: ["JavaScript", "DOM", "HTML", "CSS", "Bootsrap"],
    category: "frontend",
    github: "https://github.com/mouni2619/Guvi-Daily-Tasks-15/tree/main/DOM%20DAY-3%20Task-2",
    backend:"",
    webapp: "https://65a81f4c92a6fd0098ed1595--moonlit-lollipop-d1b8d5.netlify.app/",

  },
  {
    id: 8,
    title: "React-Router",
    date: "Feb 2022",
    description:
`I've developed a React Router application featuring a navbar with options such as "All,", "Cybersecurity", "Full Stack Development", "Career", and "Data Science". Each option leads to a specific page/component displaying relevant information through cards. The card data, stored in an array of objects, is mapped to create meaningful sentences, enhancing the user experience by providing organized and informative content. Users can seamlessly navigate between sections to explore different topics which was provided. Here for styling i used css,bootstrap and MUI which is responsive for all devices.`,   
 image:
    require('../components/projectimg/router.png'),
    tags: ["React Js", "React-Router-Dom", "MUI", "Bootstrap"],
    category: "frontend",
    github: "https://github.com/mouni2619/React-Router-App",
    backend:"",
    webapp: "https://65c95f748e861274066cdeb8--magenta-figolla-a767d3.netlify.app/",
  },
  {
    id: 9,
    title: "Shopping Cart",
    date: "Jan 2024",
    description:
      "A android quiz app made with Java and Firebase. It has a login page where users can log in with their Google account. It has a sidebar where users can see all the quiz categories and can create a new quiz. It has a leaderboard where users can see the top 10 scorers. It has a search bar where users can search for a particular quiz.",
    image:require('../components/projectimg/shopping.png'),
    tags: ["React Js", "Context-API", "CSS", "Bootstrap"],
    category: "frontend",
    github: "https://github.com/mouni2619/React_ContextAPI",
    backend:"",
    webapp: "https://65d0e5ae82ab72a1ffb10157--leafy-cannoli-a56361.netlify.app/",
  },
  {
    id: 10,
    title: "FileSystem",
    date: "Mar 2024",
    description:
"This Node.js code sets up a basic Express server that provides two main endpoints for handling file operations.this server provides a simple API for creating text files with timestamps and listing existing files, demonstrating basic file system operations in a Node.js environment using Express.",    image:
    require('../components/projectimg/file.png'),
    tags: ["Node Js", "Express Js"],
    category: "backend",
    github: "https://github.com/mouni2619/Nodejs-FileSystem",
    webapp: "https://nodejs-filesystem-8syx.onrender.com/",
  },
  {
    id: 11,
    title: "Hall-Booking-API",
    date: "Mar 2024",
    description:
"This Hall Booking Application API sets up a server using Express.js, a web framework for Node.js, to manage rooms and bookings for a hall booking application. It integrates with MongoDB, a NoSQL database, using the MongoDB Node.js driver. The code defines several routes to handle different functionalities: 🖊️POST ,📖GET data",    image:
    require('../components/projectimg/hall.png'),
    tags: ["Nodejs", "Expressjs", "MongoDB", "Dotenv"],
    category: "backend",
    github: "https://github.com/mouni2619/Hall-Booking-API",
    webapp: "https://hall-booking-api-7.onrender.com/",
  },
 
];


